// Range Slider - https://www.cssscript.com/custom-range-slider-input/

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.rangeSlider=t():e.rangeSlider=t()}(this,(()=>{return e={138:e=>{e.exports=(e,t={})=>{const a=e=>!isNaN(e)&&+e+""==e+"",i=(e=0,t=0)=>({min:e,max:t}),n=e=>{[k,F].forEach(e)},m=(e,t,a)=>{if(e)return t;a()},s=(e,t,a="")=>{e.setAttribute(t,a)},l=(e,t)=>{e.removeAttribute(t)},r=(e,t,a,i=!0)=>{e.addEventListener(t,a,i?{passive:!1,capture:!0}:{})},d=(e,t,a,i=!0)=>{e.removeEventListener(t,a,i?{passive:!1,capture:!0}:{})},o=(e,a)=>{t[e]={}.hasOwnProperty.call(t,e)?t[e]:a},u=(e,a)=>t.orientation===H?e:a,b=e=>1===e?Q.max:Q.min,x=()=>{let e=!1;a(t.min)&&a(t.max)||(e=!0),t.min=e?1:+t.min,t.max=e?1:+t.max},h=()=>{t.thumbsDisabled instanceof Array?(1===t.thumbsDisabled.length&&t.thumbsDisabled.push(!1),1!==t.thumbsDisabled.length&&2!==t.thumbsDisabled.length&&(t.thumbsDisabled=[!1,!1])):t.thumbsDisabled=[t.thumbsDisabled,t.thumbsDisabled],t.thumbsDisabled[0]=!!t.thumbsDisabled[0],t.thumbsDisabled[1]=!!t.thumbsDisabled[1]},p=(e,a=!1,n=!0,m=!0)=>{const r=i(le[Q.min].value,le[Q.max].value);e=e||r,le[Q.min].value=e.min,le[Q.max].value=ne||a?e.max:e.min+ae,g(),K.min>K.max&&(Q.min=+!Q.min,Q.max=+!Q.max,l(re[Q.min],V),l(re[Q.max],P),s(re[Q.min],P),s(re[Q.max],V),ne&&(ne=ne===k?F:k),g()),ee=a?K:e;let d=!1;(r.min!==le[Q.min].value||a)&&(d=!0),(r.max!==le[Q.max].value||a)&&(d=!0),d&&(n&&t.onInput&&t.onInput([K.min,K.max],m),E(),c(),D(),y())},g=()=>{n((e=>{K[e]=+le[Q[e]].value}))},c=()=>{n((e=>{re[Q[e]].style[u("top","left")]=`calc(${(K[e]-t.min)/te*100}% + ${(.5-(K[e]-t.min)/te)*u(W,U)[e]}px)`}))},D=()=>{const a=e.getBoundingClientRect(),i=(.5-(K.min-t.min)/te)*u(W,U).min/u(a.bottom-a.top,a.right-a.left),n=(.5-(K.max-t.min)/te)*u(W,U).max/u(a.bottom-a.top,a.right-a.left);se.style[u("top","left")]=100*((K.min-t.min)/te+i)+"%",se.style[u("height","width")]=100*((K.max-t.min)/te-(K.min-t.min)/te-i+n)+"%"},v=()=>{n(((e,a)=>{Z[e]=t.thumbsDisabled[a]?K[e]:t[e]}))},f=()=>{n(((e,a)=>{t.disabled||t.thumbsDisabled[a]?l(re[b(a)],O):s(re[b(a)],O,0)}))},y=()=>{n((e=>{s(re[Q[e]],"aria-valuemin",t.min),s(re[Q[e]],"aria-valuemax",t.max),s(re[Q[e]],"aria-valuenow",K[e]),s(re[Q[e]],"aria-valuetext",K[e])}))},w=()=>{t.disabled?s(e,J):l(e,J)},S=()=>{t.thumbsDisabled.forEach(((e,t)=>{const a=b(t);e?(s(re[a],J),s(re[a],"aria-disabled",!0)):(l(re[a],J),s(re[a],"aria-disabled",!1))}))},_=(e,a=!1)=>{t[e]=a,x(),n((e=>{le[0][e]=t[e],le[1][e]=t[e]})),te=t.max-t.min,p("",!0,!0,!1),v()},$=()=>{t.orientation===H?s(e,Y):l(e,Y),se.style[u("left","top")]="",se.style[u("width","height")]="",re[0].style[u("left","top")]="",re[1].style[u("left","top")]=""},E=()=>{n((e=>{U[e]=z(M(re[Q[e]]).width),W[e]=z(M(re[Q[e]]).height)}))},R=(a,i)=>{const n=e.getBoundingClientRect(),m=i.getBoundingClientRect(),s=(u(m.top-n.top,m.left-n.left)+(a[`client${u("Y","X")}`]-i.getBoundingClientRect()[u("top","left")])-(ne?(.5-(K[ne]-t.min)/te)*u(W,U)[ne]:0))/u(n.bottom-n.top,n.right-n.left)*te+t.min;return s<t.min?t.min:s>t.max?t.max:s},T=(e,t)=>!e.target.classList.contains(t),A=(e,a=!0)=>{let n=!1;if(!t.disabled&&(T(e,"range-slider__thumb")&&T(e,"range-slider__range")||t.rangeSlideDisabled&&T(e,"range-slider__thumb"))&&(n=!0),n&&t.thumbsDisabled[0]&&t.thumbsDisabled[1]&&(n=!1),n){const n=R(e,se),m=q(K.min-n),s=q(K.max-n);if(t.thumbsDisabled[0])n>=K.min&&(p(i(K.min,n),!0,!a),C(e,Q.max,re[Q.max],!a));else if(t.thumbsDisabled[1])n<=K.max&&(p(i(n,K.max),!0,!a),C(e,Q.min,re[Q.min],!a));else{let t=Q.max;m===s?p(i(K.min,n),!0,!a):(p(i(m<s?n:K.min,s<m?n:K.max),!0,!a),t=m<s?Q.min:Q.max),C(e,t,re[t],!a)}a&&A(e,!1)}},L=(e,t)=>{E(),s(t,X),me=R(e,t),ie=!0},C=(e,a,i,n=!0)=>{t.disabled||t.thumbsDisabled[b(a)]||(L(e,i),ne=Q.min===a?k:F,n&&t.onThumbDragStart&&t.onThumbDragStart())},B=e=>{if(ie){const a=R(e,se),n=a-me;let m=K.min,s=K.max;const l=ne?Z.min:t.min,r=ne?Z.max:t.max;ne&&ne!==k||(m=ne?a:ee.min+n),ne&&ne!==F||(s=ne?a:ee.max+n),m>=l&&m<=r&&s>=l&&s<=r?(p({min:m,max:s}),me=a):(m>r&&ne&&(p(i(r,r)),me=a),s<l&&ne&&(p(i(l,l)),me=a),m<l&&(p(i(l,ne?K.max:K.max-K.min+l)),me=a),s>r&&(p(i(ne?K.min:K.min-K.max+r,r)),me=a)),ne||v()}},I=()=>{ie&&(l(re[0],X),l(re[1],X),l(se,X),ie=!1,ne?t.onThumbDragEnd&&t.onThumbDragEnd():t.onRangeDragEnd&&t.onRangeDragEnd())},N=()=>{E(),c(),D()},j=()=>{const e=z(le[0].step);return le[0].step===G?G:0===e||isNaN(e)?1:e},q=Math.abs,z=parseFloat,M=window.getComputedStyle,k="min",F="max",G="any",H="vertical",O="tabindex",P="data-lower",V="data-upper",X="data-active",Y="data-vertical",J="data-disabled",K=i(),Q=i(0,1),U=i(),W=i(),Z=i();let ee=i(),te=0,ae=0,ie=!1,ne=!1,me=0;o("rangeSlideDisabled",!1),o("thumbsDisabled",[!1,!1]),o("orientation","horizontal"),o("disabled",!1),o("onThumbDragStart",!1),o("onRangeDragStart",!1),o("onThumbDragEnd",!1),o("onRangeDragEnd",!1),o("onInput",!1),o("value",[25,75]),o("step",1),o("min",0),o("max",100),x(),h(),e.innerHTML=`<input type="range" min="${t.min}" max="${t.max}" step="${t.step}" value="${t.value[0]}" disabled><input type="range" min="${t.min}" max="${t.max}" step="${t.step}" value="${t.value[1]}" disabled><div role="slider" class="range-slider__thumb" ${P}></div><div role="slider" class="range-slider__thumb" ${V}></div><div class="range-slider__range"></div>`,e.classList.add("range-slider");const se=e.querySelector(".range-slider__range"),le=e.querySelectorAll("input"),re=e.querySelectorAll(".range-slider__thumb");return te=t.max-t.min,p("",!0,!1),v(),w(),S(),f(),$(),r(e,"pointerdown",(e=>{A(e)})),Array.from(re).forEach(((e,a)=>{r(e,"pointerdown",(t=>{C(t,a,e)})),r(e,"keydown",(e=>{e.which>=37&&e.which<=40&&(e.preventDefault(),((e,a)=>{const i=(37===a||40===a?-1:1)*u(-1,1);if(!t.disabled&&!t.thumbsDisabled[b(e)]){let t=j();t=t===G?1:t;let a=K.min+t*(Q.min===e?i:0),n=K.max+t*(Q.max===e?i:0);a>Z.max&&(a=Z.max),n<Z.min&&(n=Z.min),p({min:a,max:n},!0)}})(a,e.which))}))})),r(se,"pointerdown",(e=>{(e=>{t.disabled||t.rangeSlideDisabled||(L(e,se),ae=K.max-K.min,ne=!1,t.onRangeDragStart&&t.onRangeDragStart())})(e)})),r(document,"pointermove",B),r(document,"pointerup",I),r(window,"resize",N),{min:(e=!1)=>m(!e&&0!==e,t.min,(()=>{_(k,e)})),max:(e=!1)=>m(!e&&0!==e,t.max,(()=>{_(F,e)})),step:(e=!1)=>m(!e,j(),(()=>{le[0].step=e,le[1].step=e,p("",!0,!0,!1)})),value:(e=!1)=>m(!e,[K.min,K.max],(()=>{p(i(e[0],e[1]),!0,!0,!1),v()})),orientation:(e=!1)=>m(!e,t.orientation,(()=>{t.orientation=e,$(),p("",!0,!0,!1)})),disabled:(e=!0)=>{t.disabled=!!e,w()},thumbsDisabled:(e=[!0,!0])=>{t.thumbsDisabled=e,h(),v(),f(),S()},rangeSlideDisabled:(e=!0)=>{t.rangeSlideDisabled=!!e},currentValueIndex:()=>ne?ne===k?0:1:-1,removeGlobalEventListeners:()=>{d(document,"pointermove",B),d(document,"pointerup",I),d(window,"resize",N)}}}}},t={},function a(i){var n=t[i];if(void 0!==n)return n.exports;var m=t[i]={exports:{}};return e[i](m,m.exports,a),m.exports}(138);var e,t}));

class FacetFiltersForm extends HTMLElement {

  static _prefix = window.KT_PREFIX || '';

  constructor() {

    super();


    this._prefix = FacetFiltersForm._prefix;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const isDesktop = this.dataset.location !== 'mobile';

    facetForm.addEventListener('change', (event) => {
      const checkbox = event.target;
      if (!checkbox || checkbox.type !== 'checkbox') return;
      const groupItem = checkbox.closest('.facets__item--group');
      if (!groupItem) return;
      const header = checkbox.closest('.facets__group-header');
      const childrenContainer = groupItem.querySelector('.facets__group-children-inner');
      if (!childrenContainer) return;
      const childCheckboxes = childrenContainer.querySelectorAll('input[type="checkbox"]');

      if (header) {
        // Parent toggled — mirror state onto all children
        childCheckboxes.forEach((c) => {
          if (!c.disabled) c.checked = checkbox.checked;
        });
      } else {
        // Child toggled — sync parent: checked if all enabled children checked
        const parentCheckbox = groupItem.querySelector('.facets__group-header input[type="checkbox"]');
        if (parentCheckbox && !parentCheckbox.disabled) {
          const enabled = Array.from(childCheckboxes).filter((c) => !c.disabled);
          const allChecked = enabled.length > 0 && enabled.every((c) => c.checked);
          parentCheckbox.checked = allChecked;
        }
      }
    });

    facetForm.addEventListener('click', (event) => {
      const toggle = event.target.closest('.facets__group-toggle');
      if (!toggle) return;
      event.preventDefault();
      const groupItem = toggle.closest('.facets__item--group');
      if (!groupItem) return;
      const isOpen = groupItem.classList.toggle('facets__item--group-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isDesktop) {
        const details = toggle.closest('details');
        if (details) {
          setTimeout(() => this.adjustPopupPosition(details), 280);
        }
      }
    });

    if (isDesktop) {
      facetForm.addEventListener('click', (event) => {
        const summary = event.target.closest('.facets__summary');
        if (!summary) return;
        const details = summary.parentElement;
        requestAnimationFrame(() => {
          if (details.open) {
            this.adjustPopupPosition(details);
          } else {
            const display = details.querySelector('.facets__display');
            if (display) display.style.left = '';
          }
        });
      });
      window.addEventListener('resize', () => {
        this.querySelectorAll('.facets__disclosure[open]').forEach((d) => this.adjustPopupPosition(d));
      });
    }
  }

  adjustPopupPosition(details) {
    const display = details.querySelector('.facets__display');
    if (!display) return;
    display.style.left = '';
    const rect = display.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const edgeMargin = 16;
    const overflowRight = rect.right - (viewportWidth - edgeMargin);
    if (overflowRight > 0) {
      display.style.left = `-${overflowRight}px`;
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(`.${this._prefix}js-facet-remove`).forEach((element) => {
      element.classList.toggle(`${this._prefix}disabled`, disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('main-collection-product-grid').classList.add(`${this._prefix}loading`);
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGrid(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGrid(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('CollectionProductGrid').querySelectorAll('template').forEach(elm=>{
      elm.closest('form')?.append(elm.content.cloneNode(true));
    })
    const event = new CustomEvent('krown:main-collection-grid:filtered', {
      bubbles: true,
      detail: {
        gridElement: document.getElementById('CollectionProductGrid')
      }
    });
    document.dispatchEvent(event);
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
    if ( countEl ) {
      document.querySelectorAll('#CollectionProductCount').forEach(elm=>{
        elm.innerHTML = countEl.innerHTML;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      `#FacetFiltersForm .${this._prefix}js-filter, #FacetFiltersFormMobile .${this._prefix}js-filter`
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      `#FacetFiltersForm .${this._prefix}js-filter, #FacetFiltersFormMobile .${this._prefix}js-filter`
    );
      
    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(`.${this._prefix}js-filter`) : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .${this._prefix}js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest(`.${this._prefix}js-filter`));
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [`.${this._prefix}active-facets-mobile`, `.${this._prefix}active-facets-desktop`];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) ) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);

  }

  static renderCounts(source, target) {
    const countElementSelectors = [`.${this._prefix}facets__selected`];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }
  
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll(`.${this._prefix}no-js-list`);
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
class PriceRange extends HTMLElement {

  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => {
        element.addEventListener('change', this.onRangeChange.bind(this));
        element.addEventListener('input', this.maxCheck.bind(this));
      });

    this.setMinAndMaxValues();
    
    //const usesComma = Boolean(this.getAttribute('data-uses-comma'));
    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');
    let inputTimer = null;

    if ( this.parentElement.querySelector('[data-js-price-range-slider]') ) {
      setTimeout(()=>{
        const rangeSliderElm = this.parentElement.querySelector('[data-js-price-range-slider]');
        rangeSlider(rangeSliderElm, {
          min: Number(inputMin.getAttribute('min')),
          max: Number(inputMax.getAttribute('max')),
          value: [inputMin.value || Number(inputMin.getAttribute('placeholder')), inputMax.value || Number(inputMax.getAttribute('placeholder'))],
          onInput: values => {
            inputMin.value = `${values[0]}`;
            inputMax.value = `${values[1]}`;
            clearTimeout(inputTimer);
            inputTimer = setTimeout(()=>{
              document.querySelector(`facet-filters-form[data-location="${rangeSliderElm.id.includes('desktop') ? 'desktop' : 'mobile'}"]`).onSubmitHandler({
                target: inputMin,
                preventDefault: ()=>{return;}
              });
              document.querySelector(`facet-filters-form[data-location="${rangeSliderElm.id.includes('desktop') ? 'desktop' : 'mobile'}"]`).onSubmitHandler({
                target: inputMax,
                preventDefault: ()=>{return;}
              });
              this.onRangeChange({
                currentTarget: inputMin
              });
              this.onRangeChange({
                currentTarget: inputMax
              });
            }, 500);
          }
        }); 
      }, 500);
    }

  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  maxCheck(object) {
    let max = parseInt(object.target.max);
    let value = parseInt(object.target.value);

    if (value > max) {
      object.target.value = max
    }
  } 
}

customElements.define('price-range', PriceRange);

/* Facet group-link "active facet" chip:
   Clicking a parent group link (e.g. Bordeaux) navigates to the matching
   collection. We stash the source URL so the destination page can show a
   removable chip that returns the user to where they came from. */
(function () {
  const STORAGE_KEY = 'vino:facet-group-back';
  const CHIP_MARKER = 'data-facets-group-back';

  function readPayload() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function clearPayload() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function currentCollectionHandle() {
    const match = window.location.pathname.match(/^\/collections\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function closeIconSvg() {
    return '<svg class="svg close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60" aria-hidden="true"><polygon points="38.936,23.561 36.814,21.439 30.562,27.691 24.311,21.439 22.189,23.561 28.441,29.812 22.189,36.064 24.311,38.186 30.562,31.934 36.814,38.186 32.684,29.812"/></svg>';
  }

  // Save where we came from when a parent group link is clicked.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facets-group-link]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    const payload = {
      from: window.location.pathname + window.location.search,
      label: link.dataset.groupLabel || '',
      handle: link.dataset.groupHandle || ''
    };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch (e) {}
  });

  function injectChip() {
    const payload = readPayload();
    if (!payload) return;
    const handle = currentCollectionHandle();
    if (!handle || handle !== payload.handle) return;

    document.querySelectorAll('.active-facets').forEach((container) => {
      if (container.querySelector('[' + CHIP_MARKER + ']')) return;
      const chip = document.createElement('a');
      chip.className = 'active-facets__button active-facets__button--light button button--small button--outline js-facet-remove';
      chip.setAttribute(CHIP_MARKER, '');
      chip.href = payload.from;
      chip.innerHTML = escapeHtml(payload.label) + closeIconSvg();
      chip.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        clearPayload();
        window.location.href = payload.from;
      });
      container.prepend(chip);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectChip);
  } else {
    injectChip();
  }
  document.addEventListener('krown:main-collection-grid:filtered', injectChip);
})();

/* Exact producer list for a filtered view.

   Shopify hands the theme at most 100 filter values and picks those 100 across
   the whole collection, so once something else is filtered the Výrobca list is
   both capped and unable to prove anything about the producers it had to drop:
   240 producers carry French wine, 100 rows can be shown. filter-blocks.liquid
   therefore renders only what Shopify vouches for — correct, but short.

   The products themselves hold the real answer, so read it from them. The
   facet-vendor-index section returns the vendors of one 50-product slice of the
   *filtered* collection; walking the slices gives the exact set with exact
   counts. It runs after the page is interactive, never during the render, and
   the result is cached per filter combination, so the page itself pays nothing.
   Without JS the server-rendered list stands. */
(function () {
  const SECTION = 'facet-vendor-index';
  const VENDOR_PARAM = 'filter.p.vendor';
  /* Versioned, and the version is bumped whenever the shape or the
     correctness of what gets stored changes. The race that painted one
     selection's producers over another's also wrote that wrong answer into
     sessionStorage, where it outlived the fix: anyone still on that tab kept
     being served the poisoned entry, which is why two people looking at the
     same page saw different producers. A new prefix orphans all of it. */
  const CACHE_PREFIX = 'vino:vendor-facet:v3:';
  /* v3 also changed where the entry lives and what it carries: localStorage
     with the time it was written, so a list already paid for survives the tab
     that paid for it.

     An hour, because the entry can only be wrong in one way — a producer who
     sold out since it was written stays on offer — and that is the very fault
     being fixed. Bounding it at an hour trades twenty-six wrong names offered
     for ever against at most a handful offered until the entry expires. Long
     enough to carry someone across a visit, short enough that a morning's
     stock change is gone by lunch. */
  const CACHE_TTL_MS = 60 * 60 * 1000;
  const CONCURRENCY = 6;
  const SLICE_ATTEMPTS = 4;
  const RETRY_DELAYS = [300, 900, 2000];
  /* A burst of section renders can be answered with 429 — six at a time is
     enough to earn one — and a rate limit needs real patience, not the 300 ms
     that a dropped connection needs. Shopify says how long when it knows. */
  const THROTTLED = new Set([429, 430, 503]);
  const THROTTLED_DELAYS = [1000, 3000, 6000];
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  /* Deliberately not 'sk': Slovak collation files "Ch" as its own letter after
     H, so Château would sort between Golguz and Juran while the server-rendered
     list — the one shown whenever nothing else is filtered — keeps it with the
     C's. The two lists have to read the same way. */
  const collator = new Intl.Collator('en', { sensitivity: 'base' });

  /* Keyed by the filter combination being fetched, never a single global
     promise: the customer ticks a country while a pass for the previous
     selection is still in the air, and whatever comes back must not be painted
     over the new selection. That race is what put an unfiltered producer list,
     unfiltered counts and all, on a page filtered to Nový Zéland. */
  const inFlight = new Map();

  function vendorFilterForms() {
    return Array.from(document.querySelectorAll('facet-filters-form form'))
      .filter((form) => form.querySelector(`input[name="${VENDOR_PARAM}"]`));
  }

  /* Open the producer filter quickly enough and you catch the server's list,
     which is replaced a moment later by the exact one — the list appears to
     redraw itself for no reason. Say so instead: mark it busy while the real
     list is being worked out. */
  function setBusy(on) {
    vendorFilterForms().forEach((form) => {
      const details = form.querySelector(`input[name="${VENDOR_PARAM}"]`)?.closest('details');
      if (!details) return;
      if (on) details.setAttribute('data-vendor-facet-loading', '');
      else details.removeAttribute('data-vendor-facet-loading');
    });
  }

  /* The producer list must not be narrowed by the producers already picked,
     or choosing one would collapse the list to that one. Everything else is
     part of the question. */
  function facetQuery() {
    const params = new URLSearchParams();
    for (const [key, value] of new URLSearchParams(window.location.search)) {
      if (key === VENDOR_PARAM) continue;
      /* Only a filter can change which producers match. Everything else in the
         query string — sort_by above all, but also page, section_id and any
         campaign parameter — has to stay out of the question and out of the
         key, or the same list is fetched again for every ordering. The theme's
         AJAX submit appends sort_by to every URL it writes, so leaving it in
         meant the entry cached on load was never read again. */
      if (!key.startsWith('filter.')) continue;
      /* An empty value filters nothing. The theme leaves filter.v.price.gte=
         and filter.v.price.lte= behind after any AJAX update, and counting
         those as an active filter started this whole pass on pages where
         nothing was filtered at all. */
      if (value === '') continue;
      params.append(key, value);
    }
    return params;
  }

  /* Identity of the current selection. Everything — the cache entry, the
     in-flight request, the decision to paint — is tied to this string. */
  function stateKey() {
    const params = facetQuery();
    return [...params.entries()].map(([k, v]) => `${k}=${v}`).sort().join('&');
  }

  /* Always, on any collection page carrying the producer filter.

     Every shortcut tried here has been wrong. "Only when something else is
     filtered" left the unfiltered list offering Bobulles, Berta - Vinárstvo
     Berta and twenty-odd others whose stock is gone — collection.all_vendors
     lists a producer whose products are no longer purchasable, so clicking it
     returns nothing. "Only when Shopify hit its cap" then read the rendered
     rows, which the zero-row rule had already thinned to three, and so never
     ran on exactly the page that needed it.

     The products are the only thing that always tells the truth, so ask them
     every time. It stays off the page render regardless: idle callback, cached
     per selection, and the server list stands if anything fails. */
  function isNeeded() {
    if (!/^\/collections\//.test(window.location.pathname)) return false;
    return vendorFilterForms().length > 0;
  }

  async function fetchSliceOnce(page) {
    const params = facetQuery();
    params.set('section_id', SECTION);
    params.set('page', String(page));
    const res = await fetch(`${window.location.pathname}?${params}`, { credentials: 'same-origin' });
    if (!res.ok) {
      const error = new Error(`slice ${page}: ${res.status}`);
      error.status = res.status;
      const retryAfter = Number(res.headers.get('retry-after'));
      if (retryAfter > 0 && retryAfter <= 10) error.retryAfterMs = retryAfter * 1000;
      throw error;
    }
    const text = await res.text();
    const start = text.indexOf('{');
    const end = text.lastIndexOf('}');
    if (start < 0 || end < 0) throw new Error(`slice ${page}: no payload`);
    return JSON.parse(text.slice(start, end + 1));
  }

  /* A slice that fails takes the whole pass with it — the counts are only
     right if every slice is in — so one dropped request on a phone connection
     used to cost the customer the exact list with nothing said about it. The
     requests are ~1 KB, so retry before giving up. The jitter keeps six
     parallel retries from arriving together after a rate limit. */
  async function fetchSlice(page, stillCurrent, onThrottled) {
    let lastError;
    for (let attempt = 0; attempt < SLICE_ATTEMPTS; attempt += 1) {
      if (attempt > 0) {
        const throttled = THROTTLED.has(lastError && lastError.status);
        const delay = throttled
          ? (lastError.retryAfterMs || THROTTLED_DELAYS[attempt - 1])
          : RETRY_DELAYS[attempt - 1];
        await wait(delay + Math.floor(Math.random() * 200));
        if (stillCurrent && !stillCurrent()) throw new Error('selection changed');
      }
      try {
        return await fetchSliceOnce(page);
      } catch (error) {
        lastError = error;
        if (THROTTLED.has(error.status) && onThrottled) onThrottled();
      }
    }
    throw lastError;
  }

  /* counts.get(name) -> {total, region}: how many of this producer's matching
     bottles there are, and how many of those are Bordeaux. A producer only
     belongs in the accordion when at least one of the bottles it matched with
     is actually from the region. */
  async function collectVendors(key) {
    const stillCurrent = () => stateKey() === key;
    /* Being told to slow down is worth listening to: keep asking at the same
       rate and the retries are throttled too, and the pass dies with the list
       still short. Halve the batch each time it happens. */
    let concurrency = CONCURRENCY;
    const onThrottled = () => { concurrency = Math.max(2, Math.floor(concurrency / 2)); };
    const first = await fetchSlice(1, stillCurrent, onThrottled);
    if (!stillCurrent()) throw new Error('selection changed');
    const counts = new Map();
    const tally = (list) => list.forEach(([name, inRegion]) => {
      const entry = counts.get(name) || { total: 0, region: 0 };
      entry.total += 1;
      entry.region += inRegion ? 1 : 0;
      counts.set(name, entry);
    });
    tally(first.vendors);

    const remaining = [];
    for (let p = 2; p <= first.pages; p += 1) remaining.push(p);
    while (remaining.length) {
      const batch = remaining.splice(0, concurrency);
      const slices = await Promise.all(batch.map((p) => fetchSlice(p, stillCurrent, onThrottled).catch(() => null)));
      if (!stillCurrent()) throw new Error('selection changed');
      if (slices.some((s) => s === null)) throw new Error('slice failed');
      slices.forEach((s) => tally(s.vendors));
    }
    return counts;
  }

  function cacheKey(key) {
    return CACHE_PREFIX + window.location.pathname + '?' + key;
  }

  /* Private windows and browsers set to refuse site data throw on the first
     touch rather than on the write, so ask once and keep the answer. Falling
     back to sessionStorage keeps the old behaviour — one tab, no more — where
     localStorage is not to be had, and nothing at all is survivable: without a
     store the pass simply walks the slices again. */
  let storeChecked = false;
  let storeRef = null;
  function store() {
    if (storeChecked) return storeRef;
    storeChecked = true;
    const probe = CACHE_PREFIX + 'probe';
    try {
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      storeRef = window.localStorage;
    } catch (e) {
      try {
        window.sessionStorage.setItem(probe, '1');
        window.sessionStorage.removeItem(probe);
        storeRef = window.sessionStorage;
      } catch (e2) {
        storeRef = null;
      }
    }
    return storeRef;
  }

  /* Ours are the only keys here worth dropping. `all` is the quota path: rather
     than guess which entry to sacrifice, clear the lot and let them be earned
     again. */
  function prune(all) {
    const s = store();
    if (!s) return;
    try {
      for (let i = s.length - 1; i >= 0; i -= 1) {
        const k = s.key(i);
        if (!k || k.indexOf(CACHE_PREFIX) !== 0) continue;
        if (all) { s.removeItem(k); continue; }
        try {
          const entry = JSON.parse(s.getItem(k));
          if (!entry || !(Date.now() - entry.at <= CACHE_TTL_MS)) s.removeItem(k);
        } catch (e) { s.removeItem(k); }
      }
    } catch (e) {}
  }

  function readCache(key) {
    const s = store();
    if (!s) return null;
    try {
      const raw = s.getItem(cacheKey(key));
      if (!raw) return null;
      const entry = JSON.parse(raw);
      /* Anything that is not a v3 entry is junk left by a hand or a half-write:
         the prefix already orphans v2's bare array. */
      if (!entry || !Array.isArray(entry.counts) || typeof entry.at !== 'number') {
        s.removeItem(cacheKey(key));
        return null;
      }
      if (Date.now() - entry.at > CACHE_TTL_MS) {
        s.removeItem(cacheKey(key));
        return null;
      }
      return new Map(entry.counts);
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, counts) {
    const s = store();
    if (!s) return;
    const payload = JSON.stringify({ at: Date.now(), counts: [...counts] });
    try {
      s.setItem(cacheKey(key), payload);
    } catch (e) {
      prune(true);
      try { s.setItem(cacheKey(key), payload); } catch (e2) {}
    }
  }

  function groupInfo() {
    const node = document.querySelector('[data-facets-vendor-group]');
    if (!node) return null;
    try {
      const data = JSON.parse(node.textContent);
      return { title: data.title, handle: data.handle, members: new Set(data.vendors) };
    } catch (e) {
      return null;
    }
  }

  function row(form, vendor, count, isChild, checked) {
    const id = `vfacet-${form.id}-${encodeURIComponent(vendor).replace(/[^a-zA-Z0-9]/g, '')}`;
    const li = document.createElement('li');
    li.className = isChild
      ? `list-menu__item facets__item facets__item--child${checked ? ' facets__item--child-active' : ''}`
      : 'list-menu__item facets__item';
    const label = document.createElement('label');
    label.className = 'facet-checkbox';
    label.setAttribute('for', id);
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'styled-checkbox';
    input.name = VENDOR_PARAM;
    input.value = vendor;
    input.id = id;
    input.checked = checked;
    const span = document.createElement('span');
    span.className = 'text-size--small';
    span.textContent = `${vendor} (${count})`;
    label.appendChild(input);
    label.appendChild(span);
    li.appendChild(label);
    return li;
  }

  function paint(counts, key) {
    const group = groupInfo();
    const selected = new Set(new URLSearchParams(window.location.search).getAll(VENDOR_PARAM));
    /* The form submits 500 ms after a tick, and the list is rebuilt from
       scratch here. A repaint landing inside that window would hand the submit
       a box the customer had just ticked, unticked — so read the DOM as well
       as the URL. */
    document.querySelectorAll(`input[name="${VENDOR_PARAM}"]:checked`).forEach((input) => {
      selected.add(input.value);
    });
    const names = [...counts.keys()].sort(collator.compare);

    vendorFilterForms().forEach((form) => {
      const details = form.querySelector(`input[name="${VENDOR_PARAM}"]`)?.closest('details');
      if (!details) return;
      const display = details.querySelector('.facets__display');
      if (!display) return;

      const groupList = details.querySelector('.facets__group-children-inner');
      const groupItem = details.querySelector('.facets__item--group');

      /* The accordion can only be filled if the server drew one. Where it did
         not — a collection with no Bordeaux left in the selection — those
         producers belong in the plain list instead of nowhere. */
      const canGroup = Boolean(group && groupList && groupItem);
      const inGroup = (n) => canGroup && group.members.has(n) && counts.get(n).region > 0;
      const grouped = names.filter(inGroup);
      const flat = names.filter((n) => !inGroup(n));

      if (canGroup) {
        if (!grouped.length) {
          groupItem.closest('.facets__list--grouped')?.remove();
        } else {
          groupList.replaceChildren(...grouped.map((n) => row(form, n, counts.get(n).total, true, selected.has(n))));
          groupList.classList.toggle('facets__list--multi-column', grouped.length > 15);
          const heading = groupItem.querySelector('.facets__group-link span:last-child');
          /* Only the number is ours to rewrite. The server's heading is a
             translated phrase built around the collection title — "Bordeaux -
             všetci výrobcovia" — and rebuilding it from the title alone
             renamed the accordion to a bare "Bordeaux" the moment the pass
             landed, so the same heading read two different ways within a
             second of each other. Strip the old count, keep every word. */
          if (heading) {
            const label = heading.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
            heading.textContent = `${label} (${grouped.length})`;
          }
        }
      }

      /* /collections/bordeaux renders every producer inside the accordion and
         no plain list at all, so one has to be made or the leftovers — and on
         that page, briefly, all of them — would land nowhere and the filter
         would paint itself empty. */
      let flatList = details.querySelector('.facets__list:not(.facets__list--grouped)');
      if (!flatList && flat.length) {
        flatList = document.createElement('ul');
        flatList.className = 'facets__list list-unstyled swatch-list--text swatch-list--text-onecolumn';
        flatList.setAttribute('role', 'list');
        display.appendChild(flatList);
      }
      if (flatList) {
        flatList.replaceChildren(...flat.map((n) => row(form, n, counts.get(n).total, false, selected.has(n))));
        flatList.classList.toggle('facets__list--multi-column', flat.length > 15);
      }

      /* Never leave the customer with an empty filter: if this produced
         nothing at all, the server's list is better than a blank box. */
      if (!grouped.length && !flat.length) return;

      const selectedCount = details.querySelector('.facets__selected');
      if (selectedCount && selected.size) {
        selectedCount.textContent = selectedCount.textContent.replace(/\d+/, String(selected.size));
      }
      /* Marked on the panel, not on the <details>: an AJAX filter update
         replaces the panel and leaves the <details> element itself standing,
         so a marker kept there would outlive the list it describes and the
         customer would be left looking at the server's short list with the
         pass convinced it had already painted. */
      display.dataset.vendorFacetExact = 'true';
      display.dataset.vendorFacetKey = key;
    });
  }

  /* Is the exact list for this selection already the one on screen? run() is
     called on hover, on focus, on every click of the summary and after every
     AJAX update, and repainting an identical list on each of those would parse
     the cache and rebuild several hundred rows under the customer's cursor for
     nothing. An AJAX update replaces the markup with the server's list, which
     drops the marker, so this cannot make it skip a repaint that is due. */
  function alreadyPainted(key) {
    const forms = vendorFilterForms();
    if (!forms.length) return false;
    return forms.every((form) => {
      const display = form.querySelector(`input[name="${VENDOR_PARAM}"]`)
        ?.closest('details')
        ?.querySelector('.facets__display');
      return Boolean(display) && display.dataset.vendorFacetKey === key;
    });
  }

  async function run() {
    if (!isNeeded()) return;
    const key = stateKey();
    if (alreadyPainted(key)) return;

    const cached = readCache(key);
    if (cached) {
      if (stateKey() === key) paint(cached, key);
      return;
    }

    if (inFlight.has(key)) return inFlight.get(key);

    setBusy(true);
    const pass = collectVendors(key)
      .then((counts) => {
        writeCache(key, counts);
        /* The selection may have moved on while this was in the air. Painting
           it now would show one selection's producers over another's. */
        if (stateKey() === key) paint(counts, key);
      })
      .catch(() => {})       // server list stays; nothing breaks
      .finally(() => {
        inFlight.delete(key);
        if (!inFlight.size) setBusy(false);
      });

    inFlight.set(key, pass);
    return pass;
  }

  /* With a filter on, the rendered list is short by design — Shopify's cap —
     so fetch ahead on idle and have it ready before the customer looks.

     With nothing filtered the walk still waits for intent: it is thirty-five
     requests on /collections/vino and most visitors never open the filter at
     all. What does not have to wait is a list already paid for. Painting a
     cached one costs nothing and is the whole difference between offering
     twenty-six sold-out producers for the second or two before the pass lands
     and offering none — on every visit after the first, which is where the
     hour-long entry earns its keep. Expired entries go at the same time; this
     is the one moment we are certain to be idle. */
  function schedule() {
    const filtered = [...facetQuery().keys()].some((k) => k.startsWith('filter.'));
    if (!filtered) {
      prune(false);
      if (isNeeded() && readCache(stateKey())) run();
      return;
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 1200);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
  document.addEventListener('krown:main-collection-grid:filtered', () => setTimeout(run, 0));
  window.addEventListener('popstate', () => setTimeout(run, 0));
  /* On an unfiltered page the pass is not scheduled, so it used to start on
     the click that opens the filter and the customer read a stale list for
     three seconds — long enough to pick a producer whose stock is gone. Start
     on the intent instead: the pointer arriving over the summary, or the
     keyboard reaching it, both land well before the click. */
  function startOnIntent(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    /* The phone has no hover and taps the summary and the row in one gesture,
       so take the earliest signal it does give: opening the filter drawer. */
    if (target.closest('[data-js-sidebar-handle], .facets__drawer-handle')) {
      run();
      return;
    }
    const summary = target.closest('.facets__summary');
    if (!summary) return;
    const details = summary.closest('details');
    if (!details || !details.querySelector(`input[name="${VENDOR_PARAM}"]`)) return;
    run();
  }
  document.addEventListener('pointerover', startOnIntent);
  document.addEventListener('focusin', startOnIntent);
  document.addEventListener('touchstart', startOnIntent, { passive: true });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.facets__summary')) run();
  });
})();

/* "Bordeaux - všetci výrobcovia" inside the Oblasť accordion: hand the shopper
   over to the identical producer accordion in Výrobca instead of making them
   hunt for it. Falls through to its href (the Bordeaux collection) whenever
   that accordion isn't on the page — a collection with no Bordeaux producers,
   or no JS at all. */
(function () {
  document.addEventListener('click', (event) => {
    const jump = event.target.closest('[data-facets-vendor-jump]');
    if (!jump) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

    const form = jump.closest('form');
    if (!form) return;
    const vendorInput = form.querySelector('.facets__list--grouped input[name="filter.p.vendor"]');
    if (!vendorInput) return;
    const group = vendorInput.closest('.facets__item--group');
    const details = vendorInput.closest('details');
    if (!group || !details) return;

    event.preventDefault();

    const openDetails = jump.closest('details');
    if (openDetails && openDetails !== details) openDetails.open = false;

    if (!details.open) {
      const summary = details.querySelector('summary');
      if (summary) summary.click();
    }

    group.classList.add('facets__item--group-open');
    const toggle = group.querySelector('.facets__group-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    const firstChild = group.querySelector('.facets__item--child input');
    if (firstChild) firstChild.focus({ preventScroll: true });
    group.scrollIntoView({ block: 'nearest' });
  });
})();

/* Removable chip for a selected producer Shopify left out of its 100 filter
   values (see the Bordeaux group in snippets/filter-blocks.liquid). The filter
   is applied — the products are correct — but Shopify reports no active value
   for it, so facets.liquid renders no chip and the selection looks invisible
   above the grid. Rebuild those chips from the query string. */
(function () {
  const PARAM = 'filter.p.vendor';
  const CHIP_MARKER = 'data-facets-vendor-chip';

  function closeIconSvg() {
    return '<svg class="svg close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60" height="60" aria-hidden="true"><polygon points="38.936,23.561 36.814,21.439 30.562,27.691 24.311,21.439 22.189,23.561 28.441,29.812 22.189,36.064 24.311,38.186 30.562,31.934 36.814,38.186 32.684,29.812"/></svg>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function urlWithout(vendors, dropped) {
    const params = new URLSearchParams(window.location.search);
    params.delete(PARAM);
    vendors.filter((v) => v !== dropped).forEach((v) => params.append(PARAM, v));
    const query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function injectVendorChips() {
    const vendors = new URLSearchParams(window.location.search).getAll(PARAM);
    if (!vendors.length) return;

    document.querySelectorAll('.active-facets').forEach((container) => {
      container.querySelectorAll('[' + CHIP_MARKER + ']').forEach((node) => node.remove());

      const labelled = new Set(
        Array.from(container.querySelectorAll('.active-facets__button'))
          .map((node) => node.textContent.trim())
      );
      const clearAll = container.querySelector('.button--solid');

      vendors.forEach((vendor) => {
        if (labelled.has(vendor)) return;
        const chip = document.createElement('a');
        chip.className = 'active-facets__button active-facets__button--light button button--small button--outline js-facet-remove';
        chip.setAttribute(CHIP_MARKER, '');
        chip.href = urlWithout(vendors, vendor);
        chip.innerHTML = escapeHtml(vendor) + closeIconSvg();
        if (clearAll) {
          container.insertBefore(chip, clearAll);
        } else {
          container.appendChild(chip);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectVendorChips);
  } else {
    injectVendorChips();
  }
  document.addEventListener('krown:main-collection-grid:filtered', injectVendorChips);
})();

/* Move the top pagination (rendered only on page > 1) into the heading row
   next to the sort dropdown. Runs on initial load and after AJAX filter
   updates that re-render #CollectionProductGrid. */
(function () {
  function placeTopPagination() {
    const node = document.querySelector('[data-collection-top-pagination]');
    if (!node) return;
    const heading = document.querySelector('.section-heading--facets');
    if (!heading) return;
    const sort = heading.querySelector('.section-heading__sort');
    if (sort) {
      if (node.nextElementSibling !== sort) heading.insertBefore(node, sort);
    } else if (node.parentElement !== heading) {
      heading.appendChild(node);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeTopPagination);
  } else {
    placeTopPagination();
  }
  document.addEventListener('krown:main-collection-grid:filtered', placeTopPagination);
})();

/* Collection "Load more": fetches the next paginated page and appends its
   product items to the current grid without changing the URL. Pagination
   (top + bottom) is left in place so users can also page-jump. */
(function () {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-load-more]');
    if (!button || button.dataset.loading === '1') return;
    const nextUrl = button.getAttribute('data-next-url');
    if (!nextUrl) return;

    event.preventDefault();
    button.dataset.loading = '1';
    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Load more fetch failed: ' + response.status);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const currentGrid = document.getElementById('main-collection-product-grid');
      const newGrid = doc.getElementById('main-collection-product-grid');
      if (!currentGrid || !newGrid) throw new Error('Grid element not found');

      const newItems = newGrid.querySelectorAll('[data-js-product-item]');
      const wrapper = button.closest('.collection-load-more');
      newItems.forEach((item) => {
        if (wrapper && wrapper.parentNode === currentGrid) {
          currentGrid.insertBefore(item, wrapper);
        } else {
          currentGrid.appendChild(item);
        }
      });

      // Sync top + bottom pagination to reflect the newly loaded page
      const fetchedTopPag = doc.querySelector('[data-collection-top-pagination]');
      const existingTopPag = document.querySelector('[data-collection-top-pagination]');
      if (fetchedTopPag) {
        if (existingTopPag) {
          existingTopPag.innerHTML = fetchedTopPag.innerHTML;
        } else {
          const heading = document.querySelector('.section-heading--facets');
          const clone = fetchedTopPag.cloneNode(true);
          if (heading) {
            const sort = heading.querySelector('.section-heading__sort');
            if (sort) heading.insertBefore(clone, sort);
            else heading.appendChild(clone);
          } else {
            currentGrid.appendChild(clone);
          }
        }
      } else if (existingTopPag) {
        existingTopPag.remove();
      }

      const fetchedBottomPag = doc.querySelector('.collection-pagination--bottom');
      const existingBottomPag = document.querySelector('.collection-pagination--bottom');
      if (fetchedBottomPag && existingBottomPag) {
        existingBottomPag.innerHTML = fetchedBottomPag.innerHTML;
      } else if (fetchedBottomPag && !existingBottomPag) {
        currentGrid.appendChild(fetchedBottomPag.cloneNode(true));
      } else if (!fetchedBottomPag && existingBottomPag) {
        existingBottomPag.remove();
      }

      const newButton = doc.querySelector('[data-load-more]');
      if (newButton) {
        button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
      } else if (wrapper) {
        wrapper.remove();
      }

      document.dispatchEvent(new CustomEvent('krown:collection:load-more', {
        bubbles: true,
        detail: { items: newItems, gridElement: currentGrid }
      }));
    } catch (error) {
      console.error(error);
    } finally {
      button.dataset.loading = '';
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  });
})();